import { type JSX, useEffect } from 'react';
import { Redirect } from 'wouter';
import { useBasket } from '../state/basket-provider';

/**
 * The stored mode B house is gone, so the guest goes back to the chooser.
 *
 * `error.choose_shop` is the server refusing the CHOSEN SHOP rather than the
 * request: the house named by a choice persisted from an earlier visit has been
 * deactivated, suspended or re-tuned out of range. Retrying - which is what the
 * generic failure card offers - could only ever produce the same refusal, so the
 * recovery is to clear the choice and send the guest to choose again.
 *
 * One component rather than the same `useEffect` beside the same `<Redirect>` on
 * both screens that meet this refusal (the vitrine and the window picker), which
 * is how it was written and is one dispatch away from the two disagreeing.
 */
export function VoidShopRedirect(): JSX.Element {
  const { dispatch } = useBasket();
  useEffect(() => {
    dispatch({ type: 'FORCE_SELECT_SHOP', shopId: null });
  }, [dispatch]);
  return <Redirect to="/shops" replace />;
}
